import * as React from 'react'

import { ExternalPinSource, ListingType } from '../../types'
import { pinSource } from '../util'
import { Image } from './Pin.styles'

interface IProps {
  clickable: boolean
  selected: boolean
  src?: ExternalPinSource
}

export default function GenericPin(props: IProps) {
  const { clickable, selected, src } = props
  const uuid = selected
    ? 'f83f27f5-a6fd-4b5d-9bd0-ee2512683611'
    : 'eeadf7fb-664c-4cde-bb8d-dd1982384dc6'

  const source: string | undefined = pinSource(ListingType.EXTERNAL, selected, uuid, src)

  return (
    <Image
      clickable={clickable}
      height={selected ? 50 : 30}
      src={source}
      width={selected ? 45 : 25}
    />
  )
}
